// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e3fd88a","455":"f9687d30","977":"f11edb58"}[chunkId] + ".chunk.js";
};